import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';

import store from '@/store';
import {
  getUserStatements,
  getUserIsNew,
  createSurcharge,
  CreateSurchargePayload,
} from '@/api/statements';
import { IPagination } from '@/utils/types';
import { ErrorAlertModule } from '@/store/modules/errors';
import { errorHandler } from '@/utils/common';

@Module({ dynamic: true, store, name: 'statements' })
class Statements extends VuexModule {
  userIsNew = {
    value: false,
    loaded: false,
  };
  list = [];
  totalCount = 0;
  filters = {
    extId: '',
    statementType: '',
    createDate: '',
    status: [],
  };
  pagination = {
    pageNumber: 0,
    pageSize: 15,
  };

  @Mutation
  setStatementsList(data: any) {
    this.list = data;
  }

  @Mutation
  setTotalCount(value: number) {
    this.totalCount = value;
  }

  @Mutation
  setFilters(payload: any) {
    this.filters = payload;
  }

  @Mutation
  setPagination(payload: any) {
    this.pagination = payload;
  }

  @Mutation
  setPageSize(payload: number) {
    this.pagination.pageSize = payload;
  }

  @Mutation
  setPageNumber(payload: number) {
    this.pagination.pageNumber = payload;
  }

  @Mutation
  setUserIsNew(payload: { value: boolean; loaded: boolean }) {
    this.userIsNew = {
      value: payload.value,
      loaded: payload.loaded,
    };
  }

  @Action
  changePagination(payload: IPagination) {
    this.setPagination(payload);
  }

  @Action
  changePageSize(payload: number) {
    this.setPageSize(payload);
  }

  @Action
  changePageNumber(payload: number) {
    this.setPageNumber(payload);
  }

  @Action
  async loadAllUserStatements() {
    const { count, items } = await getUserStatements(
      this.pagination.pageNumber,
      this.pagination.pageSize,
      this.filters
    );
    this.setStatementsList(items);
    this.setTotalCount(count);
  }

  @Action
  async filter(payload: any) {
    await this.setFilters(payload);
  }

  @Action
  async getUserIsNew() {
    ErrorAlertModule.setErrorAlert('');

    try {
      const data = await getUserIsNew();
      this.setUserIsNew({ value: data.userIsNew, loaded: true });
    } catch (error) {
      errorHandler(error);
    }
  }

  @Action
  setFilterLocalStorage(payload: any) {
    localStorage.setItem('_fnp_filter_statement', JSON.stringify(payload));
  }

  @Action
  getFilterLocalStorage() {
    const filter: any = localStorage.getItem('_fnp_filter_statement');
    return JSON.parse(filter);
  }

  @Action
  deleteFilterLocalStorage() {
    localStorage.removeItem('_fnp_filter_statement');
  }

  @Action
  async createSurcharge(payload: CreateSurchargePayload) {
    ErrorAlertModule.setErrorAlert('');

    try {
      const response = await createSurcharge(payload);

      return response.id;
    } catch (e) {
      errorHandler(e);
      throw e;
    }
  }
}

export const StatementsModule = getModule(Statements);
